import { transitions } from "polished";
import { animationDuration } from "../../settings";
import throwError from "../throwError";
var defaultValues = {
  duration: "".concat(animationDuration["default"] / 1000, "s"),
  timeFunction: null
};

/**
 * Returns generated transition css with default values when aren't specified
 *
 * @param entries - Entries of definitions of transitions
 * @returns Styles object with generated transition css
 */
var transition = function transition() {
  var result = [];
  for (var _len = arguments.length, entries = new Array(_len), _key = 0; _key < _len; _key++) {
    entries[_key] = arguments[_key];
  }
  entries.forEach(function (entry) {
    var property;
    var duration = defaultValues.duration,
      timeFunction = defaultValues.timeFunction;
    entry.split(" ").forEach(function (value, index) {
      if (index === 0) {
        property = value;
      }
      if (index > 0 && parseFloat(value)) {
        duration = "".concat(parseFloat(value), "s");
      }
      if (index > 0 && !parseFloat(value)) {
        timeFunction = value;
      }
    });
    if (property) {
      if (property === "all") {
        throwError('You can\'t use "all" property in transition!');
      } else if (property === "none") {
        result.push("none");
      } else {
        var transitionArray = [property, duration];
        if (timeFunction) {
          transitionArray.push(timeFunction);
        }
        result.push(transitionArray.join(" "));
      }
    }
  });
  return transitions(result);
};
export default transition;